import { render, staticRenderFns } from "./FinishedProjectsSettings.vue?vue&type=template&id=5b45483b&scoped=true&"
import script from "./FinishedProjectsSettings.vue?vue&type=script&lang=ts&"
export * from "./FinishedProjectsSettings.vue?vue&type=script&lang=ts&"
import style0 from "./FinishedProjectsSettings.vue?vue&type=style&index=0&id=5b45483b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45483b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
